module.exports = __webpack_public_path__ + "static/img/h_item3.92e9c3f4.png";